import http from "../lib/http-common";
import authHeader from "./authHeader";

let API_URL = process.env.REACT_APP_BACKEND_URL + "/api/";

const checkReferral = ({ formData }) => {
    return http.post(API_URL + "referral/check", formData);
};

const register = ({ formData }) => {
    return http.post(API_URL + "register", formData).then((response) => {
        if (response.data.accessToken) {
            localStorage.setItem(
                "token",
                JSON.stringify(response.data.accessToken)
            );
        }

        return response;
    });
};

const checkUsername = ({ formData }) => {
    return http.post(API_URL + "username/check", formData);
};

const login = ({ formData }) => {
    return http.post(API_URL + "login", formData).then((response) => {
        if (response.data.accessToken) {
            sessionStorage.setItem("logged", true);
            localStorage.setItem(
                "token",
                JSON.stringify(response.data.accessToken)
            );
        }

        return response.data;
    });
};

const logout = () => {
    return http
        .get(API_URL + "logout", { headers: authHeader() })
        .then((response) => {
            if (response.data.success) {
                localStorage.removeItem("token");
            }

            return response.data;
        });
};

const sendResetLinkEmail = ({ formData }) => {
    return http.post(API_URL + "password/email", formData);
};

const resetPasswordLink = ({ formData }) => {
    return http.post(API_URL + "password/reset", formData);
};

const verifyEmail = (id, hash) => {
    return http.get(API_URL + `email/verify/${id}/${hash}`, {
        headers: authHeader(),
    });
};

const resendVerificationEmail = () => {
    return http.get(API_URL + "email/resend", { headers: authHeader() });
};

const authService = {
    checkReferral,
    register,
    checkUsername,
    login,
    sendResetLinkEmail,
    resetPasswordLink,
    verifyEmail,
    resendVerificationEmail,
    logout
};

export default authService;
